import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-dropdown-content',
    templateUrl: './eui-dropdown-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiDropdownContentComponent {

    @HostBinding() class = 'eui-dropdown-content';

    constructor(

    ) {}
}

/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiDropdownContentComponent,
    ],
    exports: [
        EuiDropdownContentComponent,
    ],
})
export class EuiDropdownContentModule { }
